export default __webpack_public_path__ + "static/app-store-badge-cfe2cffb05c5bd5112d46f175c3abfd5e4d1f70b104c8cd8ff4b55f97ad1838a.svg";